import { useUnit } from 'effector-react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { routes } from '../../shared/routing';
import { Button } from '../../shared/ui';
import { $verifyError } from './model';

const KNOWN = ['link_invalid', 'link_expired', 'link_other_browser', 'rate_limited'] as const;

export function AuthVerifyPage() {
  const { t } = useTranslation();
  const [error, signIn] = useUnit([$verifyError, routes.signIn.open]);
  const key =
    error && (KNOWN as readonly string[]).includes(error)
      ? (error as (typeof KNOWN)[number])
      : 'generic';
  return (
    <main className="flex h-full items-center justify-center bg-bg-0 p-4">
      <div className="w-full max-w-sm space-y-4 rounded-xl border border-border-subtle bg-bg-1 p-6 text-center shadow-popover">
        {error ? (
          <>
            <h1 className="text-lg font-semibold">{t('signIn.title')}</h1>
            <p role="alert" className="text-sm text-text-2">
              {t(`signIn.errors.${key}`)}
            </p>
            <Button
              variant="primary"
              onClick={() => {
                void signIn();
              }}
            >
              {t('account.signIn')}
            </Button>
          </>
        ) : (
          <p role="status" className="flex items-center justify-center gap-2 text-sm text-text-2">
            <Loader2 className="size-4 animate-spin" aria-hidden />
            {t('signIn.verifying')}
          </p>
        )}
      </div>
    </main>
  );
}
